import { render, staticRenderFns } from "./CompanyReportTabTakenCompany.vue?vue&type=template&id=e68ec278"
import script from "./CompanyReportTabTakenCompany.vue?vue&type=script&lang=js"
export * from "./CompanyReportTabTakenCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports